<template>
  <ui-content title="Orden de Servicio: Detalle">
    <ui-spinner v-if="loadingView"></ui-spinner>
    <template v-else>
      <ui-card>
        <div class="row">
          <div class="col-lg-4">
            <label for="" class="form-label">Código:</label>
            <p>{{ orden.codigo }}</p>
          </div>
          <div class="col-lg-4">
            <label for="" class="form-label">Servicio:</label>
            <p>{{ orden.servicio }}</p>
          </div>
          <div class="col-lg-4">
            <label for="" class="form-label">Fecha:</label>
            <p>
              {{ orden.fecha | date }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label for="" class="form-label">Vehículo:</label>
            <p>{{ orden.vehiculo }}</p>
          </div>
          <div class="col-4">
            <label for="" class="form-label">Guía:</label>
            <p>{{ orden.guia }}</p>
          </div>
          <div class="col-4">
            <label for="" class="form-label">Asistente:</label>
            <p>{{ orden.asistente }}</p>
          </div>
        </div>
        <template v-if="estaLiquidado">
          <hr />
          <div class="row">
            <div class="col-4">
              <router-link
                :to="{ name: 'liquidaciones', query: { codRegistro: orden.codigo } }"
                class="btn btn-sm btn-outline-success font-weight-bolder"
              >
                Ver Liquidación
              </router-link>
            </div>
            <div class="col-4">
              <label for="" class="form-label">Fecha Liquidación:</label>
              <p>
                {{ containers.liquidado.fecha | date('YYYY-MM-DD HH:mm:ss', 'DD-MM-YYYY HH:mm') }}
              </p>
            </div>
          </div>
        </template>
      </ui-card>
      <ui-card v-if="orden" title="Registros" body-class="p-0">
        <template #toolbar>
          <button
            v-if="!estaLiquidado"
            @click="onClickDetallesCabecera"
            class="btn btn-primary btn-bold btn-sm ml-2"
          >
            Detalles
          </button>
          <button @click="onImprimir" class="ml-2 btn btn-outline-secondary btn-bold btn-sm">
            Imprimir
          </button>
        </template>
        <ui-spinner v-if="registros == null"></ui-spinner>
        <div v-else>
          <Table :columns="tableColumns" :rows="registros" :columnID="'idBibliaRegistro'">
            <template #rowhoraRecojo="{ val }">
              {{ val && $dayjs(val, 'HH:mm:ss').format('HH:mm') }}
            </template>
            <template #rowrenlaceTren="{ val }">
              {{ val && $dayjs(val, 'HH:mm:ss').format('HH:mm') }}
            </template>
            <template #rowrecojoPisac="{ val }">
              {{ val == 1 ? 'Sí' : 'No' }}
            </template>
          </Table>
        </div>
      </ui-card>
      <modal-orden-detalles
        v-if="orden != null && modalDetalles"
        :show="modalDetalles"
        @close="onCloseModalOrdenDetalles"
        :orden="orden"
      />
    </template>
  </ui-content>
</template>
<script>
import {
  getColumnsPerService,
  getTableColumns,
} from '../../modules/biblia/helpers/getColumnsPerService';
import pdfOrdenRegistros from '../../pdfs/pdfOrdenRegistros';
import Table from '../../modules/shared/components/Table.vue';

const ModalOrdenDetalles = () =>
  import(/* webpackChunkName: "modal-orden-detalles" */ '@/components/ModalOrdenDetalles');

export default {
  layout: 'app',
  components: {
    ModalOrdenDetalles,
    Table,
  },
  data() {
    return {
      servicio: null,
      fecha: '',
      vehiculo: null,
      guia: null,
      asistente: null,
      horaSalida: '',
      transfer: '',
      observacion: '',
      awanacancha: false,
      codigo: '',
      // loaders
      loadingView: true,
      loadingFetchCabecera: false,
      loadingCabecera: false,
      modalDetalles: false,
      // containers
      orden: null,
      registros: null,
      containers: {
        liquidado: null,
      },
    };
  },
  async created() {
    let vm = this;
    let response = null;

    try {
      response = await vm.axios.get(`/ordenes/${vm.$route.params.idOrden}/registros`);
    } catch (error) {
      vm.$router.push({
        name: 'ordenes',
      });
      return;
    }

    vm.orden = {
      idOrden: vm.$route.params.idOrden,
      ...response.data.content.orden,
    };

    vm.registros = response.data.content.registros;

    vm.containers.liquidado = response.data.content.liquidado;

    vm.loadingView = false;
  },
  computed: {
    resumen() {
      const vm = this;
      let recomendaciones = [];
      recomendaciones = vm.registros.filter((item) => (item.recomendacionesGuia ?? '').trim());
      return {
        recomendaciones,
      };
    },
    estaLiquidado() {
      return this.containers.liquidado ? true : false;
    },
    tableColumns() {
      let columnsPerService = getColumnsPerService(this.orden.idServicio);
      columnsPerService = columnsPerService.filter((item) => item != 'estado');
      return getTableColumns(columnsPerService);
    },
  },
  methods: {
    onClickDetallesCabecera() {
      this.modalDetalles = true;
    },
    onCloseModalOrdenDetalles(pRegistrosGuardados) {
      let vm = this;
      vm.modalDetalles = false;
      if (pRegistrosGuardados) {
        vm.ordenRegistros = null;
        vm.fetchOrdenDeServicioRegistros();
      }
    },
    fetchOrdenDeServicioRegistros() {
      let vm = this;

      vm.registros = [];

      vm.axios.get(`/ordenes/${vm.orden.idOrden}/registros`).then((response) => {
        vm.registros = response.data.content.registros;
      });
    },
    onImprimir() {
      const vm = this;

      const registros = [...vm.registros].map((item) => ({
        ...item,
        horaRecojo: item.horaRecojo ? vm.$dayjs(item.horaRecojo, 'HH:mm:ss').format('HH:mm') : '',
        enlaceTren: item.enlaceTren ? vm.$dayjs(item.enlaceTren, 'HH:mm:ss').format('HH:mm') : '',
        recojoPisac: item.recojoPisac ? 'Sí' : '',
      }));

      // añadiendo 5 filas extras para ingresar manualmente

      if (registros.length) {
        let empty = { ...registros[0] };

        Object.keys(empty).forEach((key) => {
          empty[key] = {
            text: '',
            margin: [0, 0, 0, 10],
          };
        });

        registros.push(...[empty, empty, empty, empty, empty]);
      }

      const orden = {
        ...vm.orden,
        fecha: vm.orden.fecha ? vm.$dayjs(vm.orden.fecha, 'YYYY-MM-DD').format('DD-MM-YY') : '',
        horaSalida: vm.orden.horaSalida
          ? vm.$dayjs(vm.orden.horaSalida, 'HH:mm:ss').format('HH:mm')
          : '',
        conductor: vm.orden.otroConductor || vm.orden.conductor || '',
      };

      pdfOrdenRegistros({
        registros: registros,
        orden,
        resumen: vm.resumen,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format('DD-MM-YY HH:mm'),
      });
    },
  },
};
</script>
